import { useMutation } from '@apollo/client'
import {
  UpdateAttendanceToleranceSettingDocument,
  type UpdateAttendanceToleranceSettingMutationVariables,
} from 'generated/resources/graphql'

export const useUpdateToleranceSetting = () => {
  const [updateToleranceSetting, { loading }] = useMutation(
    UpdateAttendanceToleranceSettingDocument
  )

  return {
    loading,
    update(id: string, values: Omit<UpdateAttendanceToleranceSettingMutationVariables, 'id'>) {
      return updateToleranceSetting({
        variables: {
          ...values,
          id,
        },
      })
    },
  }
}
